export const elementUiSize = (value: string|null) => [null, 'medium', 'small', 'mini'].includes(value)
